import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/auth.guard';
import { NgModule } from '@angular/core';
import { GraphsMainComponent } from './graphs-main.component';
import { ProgramsComponent } from './programs/programs.component';
import { TargetsComponent } from './targets/targets.component';
import { BehaviorsComponent } from './behaviors/behaviors.component';
import { AnnotationsComponent } from './annotations/annotations.component';
import { MixedComponent } from './mixed/mixed.component';
const routes: Routes = [
  {
    path: 'graphs',
    redirectTo: 'graphs/:patientID',
    pathMatch: 'full',
  },

  {
    path: 'graphs/:patientID',
    redirectTo: 'graphs/:patientID/targets',
    pathMatch: 'full',
  },
  {
    path: 'graphs/:patientID',
    component: GraphsMainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'programs',
        component: ProgramsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'targets',
        component: TargetsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'behaviors',
        component: BehaviorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'mixed',
        component: MixedComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'annotations',
        component: AnnotationsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class GraphsRoutingModule {}
